import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Plus } from '@phosphor-icons/react';

import {
  Button,
  InternalPage,
  List,
  Spacer,
  HomeLink,
} from 'theSource/components';
import { mapFamilyMembersPageData } from './utils';
import { DependentsResponseDto } from '../types';

interface MyFamilyMembersViewPageProps {
  data: DependentsResponseDto;
}

export const MyFamilyMembersViewPage = ({
  data,
}: MyFamilyMembersViewPageProps) => {
  const { t } = useTranslation('pages.familyMembers');
  const navigate = useNavigate();

  const handleAddNewFamilyMember = () => navigate('new');

  const pageData = useMemo(
    () => data && mapFamilyMembersPageData(data.data),
    [data]
  );

  return (
    <InternalPage
      testId="family-members-view-page"
      lookupCode="enroll_dependents"
      CustomActionComponent={<HomeLink />}
      customActionAlignment="left"
    >
      <Button
        data-testid="add-new-family-member-button"
        startIcon={<Plus size={14} weight="bold" />}
        label={t('addFamilyMemberButtonLabel')}
        variant="tertiary"
        onClick={handleAddNewFamilyMember}
      />
      <Spacer height={3} />
      <List
        items={pageData}
        isCombined={false}
        spacing={3}
        valueHolderVariant="body1"
      />
    </InternalPage>
  );
};
